import { Trans } from '@lingui/macro';
import { Checkbox } from '@economic/taco';
import ExternalLink from '~/app/shared/components/ExternalLink';
import RackbeatIntegrationSuccessGraphic from './images/rackbeat-onboarding-integration-success.svg';

interface Props {
    addExtraTab: boolean;
    setAddExtraTab: (addExtraTab: boolean) => void;
    children: string | JSX.Element;
}

export default function IntegrationCompleted({ addExtraTab, setAddExtraTab, children }: Props) {
    return (
        <>
            <div className="mb-2">{children}</div>
            <h2 className="text-center mt-4 mb-2">
                <Trans>Congratulations!</Trans>
            </h2>
            <div className="mt-6">
                <Trans>Rackbeat inventory has now been added to your e-conomic agreement.</Trans>
            </div>
            <div className="mt-6">
                <Trans>
                    You will soon receive an email from Rackbeat with login details for your Rackbeat agreement, so you can log in
                    and start exploring your new inventory system and how it integrates with your accounting.
                </Trans>
            </div>
            <div className="mt-6">
                <Trans>
                    You can also add Rackbeat inventory as an{' '}
                    <ExternalLink href="https://www.e-conomic.dk/support/artikler/opret-et-ekstra-faneblad">
                        extra tab
                    </ExternalLink>{' '}
                    in your e-conomic agreement. You can always remove the tab again via Settings.
                </Trans>
            </div>
            <div className="mt-4 mb-6">
                <Checkbox
                    checked={addExtraTab}
                    onChange={checked => setAddExtraTab(checked)}
                    label={
                        <span>
                            <Trans>Add as an extra tab</Trans>
                        </span>
                    }
                />
            </div>
            <div className="text-center mt-4 mb-6">
                <img src={RackbeatIntegrationSuccessGraphic} className="mx-auto w-80" />
            </div>
        </>
    );
}
